module.exports = __webpack_public_path__ + "static/media/female-avatar.70ca04a6.svg";